import React from 'react';
import { AlertTriangle } from 'react-feather';

export default function TextField({
    type = 'text',
    label,
    name,
    error,
    value,
    onChange,
    textFieldProps,
    textareaProps,
}: {
    label: string;
    name: string;
    type?: string;
    error?: false | string;
    value: any;
    textFieldProps?: React.InputHTMLAttributes<HTMLInputElement>;
    textareaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
    onChange: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => void;
}) {
    const className = `w-full block p-3 border rounded ${
        error ? 'border-red-800' : 'border-gray-800'
    }`;

    const field = (() => {
        if (type === 'textarea') {
            return (
                <textarea
                    name={name}
                    className={className}
                    onChange={onChange}
                    value={value}
                    {...textareaProps}
                ></textarea>
            );
        }
        return (
            <input
                name={name}
                type={type}
                className={className}
                onChange={onChange}
                value={value}
                {...textFieldProps}
            />
        );
    })();

    return (
        <div className="mb-7">
            <label>
                <p className={`${error ? 'text-red-900' : 'text-gray-800'}`}>
                    {label}
                </p>
                {field}
            </label>
            {error && (
                <div className="mt-4 rounded text-red-700 bg-gray-100 px-3 py-2 flex items-center">
                    <AlertTriangle />
                    <p className="ml-3">{error}</p>
                </div>
            )}
        </div>
    );
}
